import React, { Component } from "react"
import { ModalContainer } from "react-modal-dialog"
import { LoadingWithLabel } from "../../components"
export default class LoadModalWithLabel extends Component {
  render() {
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <LoadingWithLabel
              label={this.props.label}
              style={{
                position: "absolute",
                top: "40%",
                right: 0,
                left: 0
              }}
            />
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/LoadModalWithLabel.js